import { CartTotalsProps } from './CartTotals';
import { Div } from './HTMLElement';
import { t } from './i18n/i18n';
import { formatCurrency } from './util';

export const CartTotalsA = ({ cart }: CartTotalsProps) => {
  return (
    <Div className="cart-total" paddingY={3}>
      <Div className="total-to-pay" display="flex" fontWeight={700} justifyContent={'spaceBetween'}>
        <Div>{t('cart.summary.totalCost')}</Div>
        <Div>{formatCurrency(cart.totalCost)}</Div>
      </Div>
    </Div>
  );
};
